<template>
  <div class="nweaddcheck2">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="planlobby_content">
        <div class="top_content">
          <div class="item">
            <span>管理员账号</span>
            <div class="inpstyNew">
              {{ iteminfo.username }}
            </div>
          </div>
          <div class="item">
            <span>代理简称</span>
            <div class="inpstyNew">
              {{ iteminfo.shortname }}
            </div>
          </div>
          <div class="item">
            <span>代理名称</span>
            <div class="inpstyNew">
              {{ iteminfo.name }}
            </div>
          </div>
          <div class="item">
            <span>代理电话</span>
            <div class="inpstyNew">
              {{ iteminfo.telephone }}
            </div>
          </div>
          <div class="item">
            <span>代理地址</span>
            <div class="inpstyNew">
              {{ iteminfo.address }}
            </div>
          </div>
          <div class="item">
            <span>道路运输许可</span>
            <div class="inpstyNew">
              {{ iteminfo.transportlicencecode }}
            </div>
          </div>
          <div class="item">
            <span>组织机构代码</span>
            <div class="inpstyNew" v-if="iteminfo.orgcode">
              {{ iteminfo.orgcode }}
            </div>
            <div class="inpstyNew" v-else>
              {{ iteminfo.businesslicenseCode }}
            </div>
          </div>
        </div>
        <div class="card">

          <div class="planlobby_content1">
            <el-row>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.businesslicense">
                  <div>营业执照：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.businesslicense"
                      :preview-src-list="[iteminfo.businesslicense]">
                    </el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.transportlicence">
                  <div>道路运输许可证：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.transportlicence"
                      :preview-src-list="[iteminfo.transportlicence]">
                    </el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.filingvoucher">
                  <div>备案凭证：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.filingvoucher"
                      :preview-src-list="[iteminfo.filingvoucher]">
                    </el-image>
                  </div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="card_box" v-if="iteminfo.safeCertificate">
                  <div>安全资格证：</div>
                  <div class="bottextarea">
                    <el-image lazy style="width: 100%; height: 100%" :src="iteminfo.safeCertificate"
                      :preview-src-list="[iteminfo.safeCertificate]">
                    </el-image>
                  </div>
                </div>
              </el-col>
            </el-row>

            <el-row>
              <!-- <el-col :span="8">
              <div> -->
              <!-- <div>安全资格证:</div>
                <el-button type="primary" icon="el-icon-tickets" @click="yulan('safeCertificate')">点击预览</el-button> -->
              <!-- </div>
            </el-col> -->
              <el-col :span="8">
                <div v-if="iteminfo.letterOfCommit">
                  <div>承诺书:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('letterOfCommit')">点击预览</el-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="iteminfo.jobTrainingRecords">
                  <div>岗前教育培训:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('jobTrainingRecords')">点击预览</el-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="iteminfo.entryPersonInfo">
                  <div>进场人员信息:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('entryPersonInfo')">点击预览</el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <div v-if="iteminfo.entryVehicleInfo">
                  <div>进场机械车辆信息:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('entryVehicleInfo')">点击预览</el-button>
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="iteminfo.siteSafeProc">
                  <div>现场安全规程:</div>
                  <el-button type="primary" icon="el-icon-tickets" @click="yulan('siteSafeProc')">点击预览</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="button_btn">
            <button class="btn" style=" color: #17B6A1;background: #f3f4f5;" @click="returnpage">返回</button>
            <button style="background: #ff4900; color: #ffffff" @click="isshow = true">不通过</button>
            <button style="background: #17B6A1; color: #fff" @click="passinfo">
              通过
            </button>
          </div>
        </div>
      </div>
      <pdialog :isshowdialog="isshow" :imgposition="'bot'" v-model="iteminfo.cause" @closedialog="nopass"></pdialog>
    </div>
    <el-dialog title="PDF预览" :visible.sync="dialogVisible4" width="70%" center>
      <iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 600px"></iframe>
    </el-dialog>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle";
import pdialog from "@/components/pdialog.vue";
import mSuperIpt from "@/components/mSuperIpt.vue";
export default {
  name: "newaddcheck2",
  data() {
    return {
      listitem: [{ name: "代理管理" }, { name: "企业列表", path: "/motorcade/motorcade" }, { name: "详情" }],
      isshow: false,
      timeout: null,
      iteminfo: {},
      dialogVisible4: false,
      pdfSrc: ""
    };
  },
  components: {
    mTitle,
    pdialog,
    mSuperIpt,
  },
  created() {
    this.getItemInfo(window.sessionStorage.getItem("infoid"));
  },
  methods: {
    async getItemInfo(id) {
      if (!id) return;
      const { data } = await this.$http(
        "api1",
        "/fleet/fleetfleetmessage/getFleetById",
        "get",
        { id: id }
      );
      if (!data.data) return console.log("请求失败");
      this.iteminfo = data.data;
    },
    retunrnpage() {
      this.$router.push("/motorcade/newaddcheck");
    },
    async passinfo() {
      const { data } = await this.$http(
        "api1",
        "/fleet/fleetfleetmessage/fleetMessageAuditPass",
        "post",
        { ids: [this.iteminfo.id], cause: this.iteminfo.cause }
      );
      if (!data || data.msg != "success")
        return this.$message.error("操作失败");
      this.$message.success("审核成功");
      this.retunrnpage();
    },
    async nopass(val) {
      if (val == "affirm") {
        const { data } = await this.$http(
          "api1",
          "/fleet/fleetfleetmessage/fleetMessageAuditNotPass",
          "post",
          this.iteminfo
        );
        if (!data || data.msg != "success")
          return this.$message.error("操作失败");
        this.$message.success("操作成功");
        window.sessionStorage.removeItem("infoid");
        this.retunrnpage();
      } else {
        this.isshow = false;
      }
    },
    //预览
    yulan(txt) {
      let result = this.iteminfo[txt]
      if (result.includes('.pdf')) {
        this.dialogVisible4 = true
        this.pdfSrc = result
      } else {
        let url = 'http://view.officeapps.live.com/op/view.aspx?src=' + result
        window.open(url, '_target')
      }

    },
    returnpage() {
      this.$router.go(-1);
    }
  },
};
</script>
<style lang="scss" scoped>
.nweaddcheck2 {
  position: relative;
  height: 100%;

  .componentSty_content {
    position: absolute;
    top: 50px;
    bottom: 0;
    width: 100%;
    background: #fff;
  }

  .planlobby_content {
    box-sizing: border-box;
    // padding: 20px 0 0 0;
    height: 100%;
    background: #fff;

    .top_content {
      position: relative;
      height: 40%;
      padding-top: 2%;
      box-sizing: border-box;

      .item {
        margin: 0 auto;
        width: 32%;
        height: 15%;
        text-align: right;
        font-size: 80%;

        &::before {
          display: inline-block;
          content: "";
          height: 65%;
          vertical-align: middle;
        }

        .input,
        .inpstyNew {
          float: right;
          width: 72%;
          height: 65%;
          margin-left: 5%;
          text-align: left;
          background: #f3f4f5;
          border-radius: 2px;
          white-space: nowrap;
        }

        .inpstyNew {
          background: transparent;
        }

        .inpstyNew::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
        }
      }
    }

    .card {
      box-sizing: border-box;
      height: 59%;
      margin-top: 1%;
      .planlobby_content1 {
        // height: 80%;
        width: 65%;
        margin: 0 auto;
        .card_box {
          box-sizing: border-box;
          // display: inline-block;
          height: 50%;
          // width: 23%;
          margin-right: 1.3%;
          .bottextarea {
          box-sizing: border-box;
          display: inline-block;
          height: 80%;
          width: 100%;
          // margin-right: 0.3%;
          background: #f3f4f5;
          background-size: 100% 100%;
          display: flex;
            justify-content: flex-end;

          img {
            width: 100%;
            height: 100%;
          }
        }

        }
        
      }

      .button_btn {
        margin: 0 auto;
        height: 20%;
        width: 30%;

        button {
          margin-top: 5%;
          border: none;
          outline: none;
          width: 30%;
          margin-right: 3.3%;
          height: 50%;
          font-size: 80%;
          color: #17B6A1;
          background: #f3f4f5;
          border-radius: 5px;
        }

        button:last-child {
          margin: 0;
        }
      }
    }
  }

  .imgcontent {
    width: 100%;
    height: 600px;
    text-align: center;

    .img {
      width: auto;
      max-width: 100%;
      height: 100%;
    }
  }
}
</style>